import { render, staticRenderFns } from "./FullPageLoading.vue?vue&type=template&id=5938d6b6"
import script from "./FullPageLoading.vue?vue&type=script&lang=ts"
export * from "./FullPageLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports